import { printApi, type LabelPrepareProgress, type LabelPrepareSession, type LabelsResponse } from '@/lib/api/print'

const POLL_MS = 250
const TIMEOUT_MS = 30 * 60_000

export type LabelPrepareStart = () => Promise<{ data: { item: LabelPrepareSession } }>

export async function pollLabelPrepare(
  sessionId: string,
  onProgress?: (progress: LabelPrepareProgress) => void,
): Promise<LabelsResponse> {
  const started = Date.now()
  while (Date.now() - started < TIMEOUT_MS) {
    const res = await printApi.getLabelPrepare(sessionId)
    const item = res.data.item
    onProgress?.({
      percent: item.percent,
      done: item.rendered_count,
      total: item.total,
    })
    if (item.status === 'completed') {
      if (!item.labels) throw new Error('Пустой ответ рендера')
      onProgress?.({ percent: 100, done: item.total, total: item.total })
      return item.labels
    }
    if (item.status === 'failed') {
      throw new Error(item.error?.trim() || 'Рендер не удался')
    }
    await new Promise((r) => setTimeout(r, POLL_MS))
  }
  throw new Error('Рендер не завершился за отведённое время')
}

export async function startAndPollLabels(
  start: LabelPrepareStart,
  onProgress?: (progress: LabelPrepareProgress) => void,
): Promise<LabelsResponse> {
  const startRes = await start()
  const session = startRes.data.item
  onProgress?.({
    percent: session.percent,
    done: session.rendered_count,
    total: session.total,
  })
  return pollLabelPrepare(session.session_id, onProgress)
}
